<template>
    <v-container>
        <v-layout>
            <v-flex xs12>
                <StoreManagement></StoreManagement>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12>
                <DepartmentManagement></DepartmentManagement>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import StoreManagement from "../../components/store/StoreManagement.vue";
import DepartmentManagement from "../../components/department/DepartmentManagement.vue";

export default {
    components: {
        StoreManagement,
        DepartmentManagement
    },
    props: [
        
    ],
    data() {
        return {
            
        };
    },
    computed: {
        
    },
    methods: {
        
    }
};
</script>

<style>
    
</style>
